import { useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";

export default function Contact() {
  const { t, lang } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success(t("contact_sent"));
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Failed"); }
    setLoading(false);
  };

  return (
    <div data-testid="contact-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ REACH OUT ]</p>
          <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.98] mb-8">{t("contact_title")}</h1>
          <p className="text-neutral-600 max-w-md">
            {lang === "nl"
              ? "Vragen over een batch, technische specs, of samenwerking? We reageren binnen 24 uur."
              : "Questions about a batch, technical specs, or partnership? We respond within 24 hours."}
          </p>
          <div className="mt-12 space-y-4 font-mono-label text-[11px] text-neutral-600">
            <div className="border-t border-neutral-300 pt-3 flex justify-between"><span>Email</span><span>hello@peptivance.eu</span></div>
            <div className="border-t border-neutral-300 pt-3 flex justify-between"><span>Region</span><span>Netherlands</span></div>
            <div className="border-t border-neutral-300 pt-3 flex justify-between"><span>Hours</span><span>Mon—Fri · 09—17 CET</span></div>
          </div>
        </div>
        <form onSubmit={submit} className="md:col-span-7 space-y-4">
          <input data-testid="contact-name" required placeholder={t("auth_name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4" />
          <input data-testid="contact-email" required type="email" placeholder={t("auth_email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4" />
          <textarea data-testid="contact-msg" required placeholder="Message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 min-h-48" />
          <button data-testid="contact-submit" type="submit" disabled={loading} className="btn-solid">
            {loading ? "…" : "Send message →"}
          </button>
        </form>
      </div>
    </div>
  );
}
